import gql from "graphql-tag";

export const issueInvoiceForPaymentMutation = gql`
mutation issueInvoiceForPayment($payment_id: ID!, $invoice_type: InvoiceType_Enum!){
  invoice_issueInvoiceForPayment(payment_id: $payment_id, invoice_type: $invoice_type){
    payment{
      id
      invoice_number
      invoice_type
    }
    status
  }
}`;

export const addOrEditExtraInvoiceMutation = gql`mutation add_or_edit_extra_invoice($camp_participant_id: ID!, $provider: String!, $invoice_foreign_id: String!, $invoice_status: ExtraInvoice_Status, $invoice_include_in_summary: Boolean, $comment: String){
	invoice_addOrEditExtraInvoice(camp_participant_id: $camp_participant_id, provider: $provider, invoice_foreign_id: $invoice_foreign_id, invoice_status: $invoice_status, invoice_include_in_summary: $invoice_include_in_summary, comment: $comment){
		status
		camp_participant {
			id

			extra_invoices {
				id
				created_timestamp
				provider
				invoice_number
				invoice_foreign_id
				invoice_date_issued
				invoice_date_due
				invoice_amount_total
				invoice_amount_paid
				invoice_include_in_summary
				invoice_status
				invoice_items
				comment
			}
			extra_invoices_total_amount
			extra_invoices_amount_left
		}
	}
}`;

export const autoUpdateExtraInvoiceMutation = gql`mutation autoUpdateExtraInvoice($camp_participant_id: ID!,$invoice_id: String!){
  invoice_autoUpdateExtraInvoice(camp_participant_id: $camp_participant_id, invoice_id: $invoice_id){
    status
    camp_participant {
      id
      is_data_confirmed
	  pending_changes

      extra_invoices {
        id
        created_timestamp
        provider
        invoice_number
        invoice_foreign_id
        invoice_date_issued
        invoice_date_due
        invoice_amount_total
        invoice_amount_paid
        invoice_include_in_summary
        invoice_status
        invoice_items
        comment
      }
      extra_invoices_total_amount
      extra_invoices_amount_left
    }
  }
}`;

export const deleteExtraInvoiceMutation = gql`mutation deleteExtraInvoice($camp_participant_id: ID!,$invoice_id: String!){
  invoice_deleteExtraInvoice(camp_participant_id: $camp_participant_id, invoice_id: $invoice_id){
    status
    camp_participant {
      id
      is_data_confirmed
	  pending_changes

      extra_invoices {
        id
        created_timestamp
        provider
        invoice_number
        invoice_foreign_id
        invoice_date_issued
        invoice_date_due
        invoice_amount_total
        invoice_amount_paid
        invoice_include_in_summary
        invoice_status
        invoice_items
        comment
      }
      extra_invoices_total_amount
      extra_invoices_amount_left
    }
  }
}`;

export const issueOrderForReservationMutation = gql`
  mutation invoice_issueOrderForReservation($camp_participant_id: ID!){
    issueOrderForReservation(camp_participant_id: $camp_participant_id){
      status
      camp_participant {
        id
        order_number
      }
    }
  }`;
